import React, {Fragment} from "react";
import {useInterSectionObserver} from "hooks";
import AssetListLayout from "../AssetListLayout";
import ListTypeItem from "../ListTypeItem";
import styles from "./index.module.scss";

function ListTypeList({title, type, assetSearchParams, data, fetchNextPage, hasNextPage}) {
  const [, loadingRef] = useInterSectionObserver(fetchNextPage, {});
  const hasPagination = !!data?.pages;

  return (
    <AssetListLayout title={title} type={type} assetSearchParams={assetSearchParams}>
      <ul className={styles.list_container}>
        {hasPagination &&
          data?.pages?.map((page, idx) => (
            <Fragment key={idx}>
              {page?.map(asset => (
                <div className={styles.asset_wrapper} key={asset.id}>
                  <ListTypeItem data={asset} />
                </div>
              ))}
            </Fragment>
          ))}

        {!hasPagination &&
          data?.map(asset => (
            <div className={styles.asset_wrapper} key={asset.id}>
              <ListTypeItem data={asset} />
            </div>
          ))}

        {hasNextPage && <div className={styles.load_more} ref={loadingRef}></div>}
      </ul>
    </AssetListLayout>
  );
}

export default ListTypeList;
